export default __webpack_public_path__ + "static/media/grohe.89c33b51.svg";